import PropTypes from 'prop-types';
import ImageMediaItem from './ImageMediaItem.jsx';
import VideoMediaItem from './VideoMediaItem.jsx';

export default function MediaItem({item, isActive}) {
    return (
        <div className="w-full flex-shrink-0 px-2">
            {item.videoId ? (
                <VideoMediaItem item={item} isActive={isActive} />
            ) : (
                <ImageMediaItem item={item} />
            )}
        </div>
    );
}

MediaItem.propTypes = {
    item: PropTypes.shape({
        videoId: PropTypes.string,
        image: PropTypes.object,
        title: PropTypes.string,
    }).isRequired,
    isActive: PropTypes.bool,
};
